import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Company } from "../../../../auth/models";
import { ListTender } from '../../../models';
import { TendersService } from '../../../services';

@Component({
    selector: 'tbody[jft-tenders-list]',
    templateUrl: './tenders-list.component.html',
    styleUrls: ['./tenders-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TendersListComponent implements OnInit, OnDestroy {

    public tenders: ListTender[] = [];
    public orderChangeSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private service: TendersService,
        public company: Company,
    ) {
    }

    public ngOnInit() {
        this.tenders = this.route.snapshot.data['tenders'];
        this.orderChangeSubscription = this.service.onTendersListChange.subscribe((tenders) => {
            this.tenders = tenders;
        });
    }

    public viewTender(tender: ListTender) {
        if ((tender.status as string) == 'Draft') {
            this.router.navigate(['/tenders/new/', tender.id]);
        } else {
            this.router.navigate(['/tenders', tender.id]);
        }
    }

    public ngOnDestroy() {
        this.orderChangeSubscription.unsubscribe();
    }

}
